import bankServices from '@/api/financial/bankServices'

export default {
  namespaced: true,
  state: {
    gateways: [],
    gateway: {
      descricao: '',
      provedor: 'PAGBANK',
      ambiente: 'SANDBOX',
      clientId: '',
      clientSecret: '',
      webhookSecret: '',
      ativo: true,
      certificadoA1: null
    }
  },
  getters: {},
  mutations: {
    SET_GATEWAYS(state, data) {
      state.gateways = data
    },
    SET_GATEWAY(state, data) {
      state.gateway = data
    },
    RESET_GATEWAY(state) {
      state.gateway = {
        descricao: '',
        provedor: 'PAGBANK',
        ambiente: 'SANDBOX',
        clientId: '',
        clientSecret: '',
        webhookSecret: '',
        ativo: true,
        certificadoA1: null
      }
    }
  },
  actions: {
    loadAll({ commit }) {
      return bankServices.loadAll().then(response => {
        commit('SET_GATEWAYS', response.data)
        return response
      })
    },
    loadById({ commit }, id) {
      return bankServices.loadById(id).then(response => {
        commit('SET_GATEWAY', response.data)
        return response
      })
    },
    insert({ dispatch }, data) {
      return bankServices.insert(data).then(response => {
        dispatch('loadAll')
        return response
      })
    },
    update({ dispatch }, { id, data }) {
      return bankServices.update(id, data).then(response => {
        dispatch('loadAll')
        return response
      })
    },
    delete({ dispatch }, id) {
      return bankServices.delete(id).then(response => {
        dispatch('loadAll')
        return response
      })
    },
    reset({ commit }) {
      commit('RESET_GATEWAY')
    }
  }
}
